import { initializePostHogClient } from './src/utils/posthogClient'

try {
  void initializePostHogClient({
    forceSessionRecording:
      typeof window !== 'undefined' && window.location.pathname.startsWith('/seekers/signup'),
  })
} catch (error) {
  console.error('Unable to initialize instrumentation client analytics:', error)
}
